// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  termId: __t.u64().primaryKey().name("term_id"),
  seasonIndex: __t.u32().name("season_index"),
  seats: __t.u8(),
  openedAt: __t.timestamp().name("opened_at"),
  closed: __t.bool(),
});
